// src/components/dashboard/TimeRecordsCard.js
// Dashboard card — today's time records summary.
// Visibility gated by `time:view` via src/config/dashboardCards.js.

import { dashboardService } from "../../services/dashboardService";
import Icon from "../icons/Icon";

export const TimeRecordsCard = ({
  today,
  isLoading,
  timeRecordsStats,
  navigate,
  company,
}) => (
  <div className="dashboard-card">
    <div className="dashboard-card__header">
      <span className="dashboard-card__title">Time Records</span>
    </div>
    <div className="time-records__date">
      Today: {dashboardService.formatDisplayDate(today)}
    </div>
    <div className="time-records__list">
      <div className="time-record-item">
        <div className="time-record-item__icon time-record-item__icon--success">
          <Icon name="check" size={16} />
        </div>
        <span className="time-record-item__text">With Records</span>
        <span className="time-record-item__count">
          {isLoading ? "..." : timeRecordsStats.withRecords}
        </span>
      </div>
      <div className="time-record-item">
        <div className="time-record-item__icon time-record-item__icon--warning">
          <Icon name="info" size={16} />
        </div>
        <span className="time-record-item__text">Missing DTR</span>
        <span className="time-record-item__count">
          {isLoading ? "..." : timeRecordsStats.missingDTR}
        </span>
      </div>
      <div className="time-record-item">
        <div className="time-record-item__icon time-record-item__icon--info">
          <Icon name="plane" size={16} />
        </div>
        <span className="time-record-item__text">On Leave</span>
        <span className="time-record-item__count">
          {isLoading ? "..." : timeRecordsStats.onLeave}
        </span>
      </div>
    </div>
    <div className="dashboard-card__footer">
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          navigate(`/company/${company.slug}/time-tracking`);
        }}
        className="dashboard-card__link"
      >
        View time records →
      </a>
    </div>
  </div>
);